import MyShit from "./components/pages/home/MyShit";
import Navbar from "./components/layout/Navbar";
import Contact from "./components/pages/Contact";
import Skills from "./components/pages/Skills";
import Projects from "./components/pages/Projects";
import NavbarS from "./components/layout/NavbarS";
import { Route, Switch, HashRouter } from "react-router-dom";

function App() {
  return (
    <div
      className="text-white h-full w-full "
      style={{ backgroundColor: "#111" }}
    >
      <HashRouter>
        <div className="flex h-screen w-screen">
          <Navbar className="max-h-full" />
          <NavbarS />
          <div className="w-full relative">
            <Switch>
              <Route component={MyShit} exact path="/" />
              <Route component={Skills} exact path="/skills" />
              <Route component={Projects} exact path="/projects" />
              <Route component={Contact} exact path="/Contact" />
            </Switch>
          </div>
        </div>
      </HashRouter>
    </div>
  );
}

export default App;
